import { t } from '@lingui/macro';


// todo: Update naming to better reflect... remove redundant text
const getTranslations = ({ i18n }) => ({
  ALL_CELLS_TEXT: i18n._(t('progressQuickSelector.allCells')`All Cells`),
  ALL_CURRENTLY_ASSIGN_TEXT: i18n._(t('progressQuickSelector.allCurrentlyAssigned')`All Currently Assigned`),
  CLEAN_SELECTION_TEXT: i18n._(t('progressQuickSelector.clearSelections')`Clear Selections`),
  PROGRESS_1_TO_20_TEXT: i18n._(t('progressQuickSelector.results20')`1 - 20% Complete`),
  PROGRESS_21_TO_40_TEXT: i18n._(t('progressQuickSelector.results40')`21 - 40% Complete`),
  PROGRESS_41_TO_60_TEXT: i18n._(t('progressQuickSelector.results60')`41 - 60% Complete`),
  PROGRESS_61_TO_80_TEXT: i18n._(t('progressQuickSelector.results80')`61 - 80% Complete`),
  PROGRESS_81_TO_100_TEXT: i18n._(t('progressQuickSelector.results100')`81 - 100% Complete`),
  ACCURACY_1_TO_20_TEXT: i18n._(t('accuracyQuickSelector.results20')`1 - 20% Accuracy`),
  ACCURACY_21_TO_40_TEXT: i18n._(t('accuracyQuickSelector.results40')`21 - 40% Accuracy`),
  ACCURACY_41_TO_60_TEXT: i18n._(t('accuracyQuickSelector.results60')`41 - 60% Accuracy`),
  ACCURACY_61_TO_80_TEXT: i18n._(t('accuracyQuickSelector.results80')`61 - 80% Accuracy`),
  ACCURACY_81_TO_100_TEXT: i18n._(t('accuracyQuickSelector.results100')`81 - 100% Accuracy`),
  SELECT_TEXT: i18n._(t('progressQuickSelector.select')`Select...`)
});

export default getTranslations;
